var _rect, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 5,
    fill: "url(#paint0_linear_224_693)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9888 25.4186C20.9674 25.3993 20.9463 25.3798 20.9254 25.3605C20.8081 25.2524 20.6971 25.1503 20.5286 25.1442C20.3087 25.1363 20.0327 25.3933 19.7445 25.6617C19.3209 26.0563 18.878 26.4687 18.2539 26.4687C17.3388 26.4687 17.1903 25.7899 17.041 25.1079C16.9562 24.7202 16.871 24.3307 16.5484 24.3307C16.1807 24.3307 15.9707 24.5409 15.7334 24.7784C15.2951 25.2169 14.7912 25.7212 13.488 25.7212C13.2784 25.7212 13.1084 25.5512 13.1084 25.3416C13.1084 25.1319 13.2784 24.9619 13.488 24.9619C14.4796 24.9619 14.8631 24.5782 15.1966 24.2445C15.5534 23.8874 15.8692 23.5715 16.5484 23.5715C17.4814 23.5715 17.6323 24.2613 17.7825 24.9477C17.866 25.3295 17.9492 25.7095 18.254 25.7095C18.5818 25.7095 18.9123 25.4016 19.2285 25.1071C19.6335 24.73 20.0214 24.3687 20.5553 24.388C20.714 24.3937 20.8428 24.4215 20.9529 24.464C21.0117 23.4266 21.3862 22.4739 21.9818 21.7001H12.4527C12.243 21.7001 12.0731 21.5301 12.0731 21.3205C12.0731 21.1108 12.243 20.9409 12.4527 20.9409H22.7037C23.5781 20.1947 24.7124 19.744 25.9521 19.744C26.01 19.744 26.0676 19.7454 26.125 19.7473V8.72127C26.125 7.77456 25.3504 7 24.4037 7H9.50432C9.9357 7.44681 10.2018 8.05414 10.2018 8.72127V28.1401C10.2018 28.3318 10.3581 28.4881 10.5498 28.4881H22.6186C21.7478 27.7107 21.1506 26.6335 20.9888 25.4186ZM16.5198 9.01941H23.8741C24.0838 9.01941 24.2537 9.18938 24.2537 9.39902C24.2537 9.60866 24.0838 9.77864 23.8741 9.77864H16.5198C16.3102 9.77864 16.1402 9.60866 16.1402 9.39902C16.1402 9.18938 16.3102 9.01941 16.5198 9.01941ZM16.5198 11.4037H23.8741C24.0838 11.4037 24.2537 11.5737 24.2537 11.7833C24.2537 11.993 24.0838 12.163 23.8741 12.163H16.5198C16.3102 12.163 16.1402 11.993 16.1402 11.7833C16.1402 11.5737 16.3102 11.4037 16.5198 11.4037ZM16.5198 13.788H23.8741C24.0838 13.788 24.2537 13.958 24.2537 14.1676C24.2537 14.3772 24.0838 14.5472 23.8741 14.5472H16.5198C16.3102 14.5472 16.1402 14.3772 16.1402 14.1676C16.1402 13.958 16.3102 13.788 16.5198 13.788ZM13.0188 9.77954V9.39902C13.0188 9.18938 13.1888 9.01941 13.3985 9.01941C13.6081 9.01941 13.7781 9.18938 13.7781 9.39902V9.76416C14.0928 9.81911 14.3805 9.99853 14.5678 10.2576C14.6907 10.4272 14.6528 10.6642 14.4833 10.787C14.3138 10.9098 14.0768 10.872 13.9539 10.7025C13.8626 10.5762 13.7272 10.5055 13.5712 10.5055H13.3034C13.045 10.5055 12.8323 10.7182 12.8323 10.9765C12.8323 11.2348 13.045 11.4476 13.3034 11.4476H13.4935C14.171 11.4476 14.7238 12.0005 14.7238 12.6779C14.7238 13.247 14.3295 13.7433 13.7781 13.8749V14.2554C13.7781 14.465 13.6081 14.635 13.3985 14.635C13.1888 14.635 13.0188 14.465 13.0188 14.2554V13.8902C12.7041 13.8353 12.4164 13.6559 12.2291 13.3968C12.1062 13.2272 12.1441 12.9903 12.3136 12.8674C12.4832 12.7446 12.7201 12.7824 12.843 12.9519C12.9343 13.0782 13.0697 13.149 13.2257 13.149H13.4935C13.7519 13.149 13.9646 12.9362 13.9646 12.6778C13.9646 12.4195 13.7519 12.2068 13.4935 12.2068H13.3034C12.6259 12.2068 12.0731 11.6539 12.0731 10.9765C12.0731 10.4074 12.4674 9.91103 13.0188 9.77954ZM12.4527 16.1723H23.8741C24.0838 16.1723 24.2537 16.3423 24.2537 16.5519C24.2537 16.7616 24.0838 16.9315 23.8741 16.9315H12.4527C12.243 16.9315 12.0731 16.7616 12.0731 16.5519C12.0731 16.3423 12.243 16.1723 12.4527 16.1723ZM12.4527 18.5566H23.8741C24.0838 18.5566 24.2537 18.7265 24.2537 18.9362C24.2537 19.1458 24.0838 19.3158 23.8741 19.3158H12.4527C12.243 19.3158 12.0731 19.1458 12.0731 18.9362C12.0731 18.7265 12.243 18.5566 12.4527 18.5566ZM25.9521 20.5033C23.6057 20.5033 21.7037 22.4053 21.7037 24.7516C21.7037 27.0979 23.6057 29 25.9521 29C28.2984 29 30.2004 27.0979 30.2004 24.7516C30.2004 22.4053 28.2984 20.5033 25.9521 20.5033ZM9.44258 8.72127V10.5438H6.34796C6.15635 10.5438 6 10.3875 6 10.1958V8.72127C6 7.77365 6.77498 7 7.72236 7C8.6686 7.00057 9.44258 7.77489 9.44258 8.72127Z",
    fill: "url(#paint1_linear_224_693)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8752 23.4867L27.5127 23.1242C27.3471 22.9586 27.0776 22.9586 26.912 23.1242L26.7701 23.2661L27.7333 24.2293L27.8752 24.0874C28.0412 23.9214 28.0412 23.6527 27.8752 23.4867Z",
    fill: "url(#paint2_linear_224_693)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1717 25.9434L24.0017 26.8615C23.9947 26.8994 24.0068 26.9384 24.0341 26.9657C24.0614 26.993 24.1004 27.0051 24.1383 26.9981L25.0563 26.828L24.1717 25.9434Z",
    fill: "url(#paint3_linear_224_693)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6044 23.4319L24.2981 25.7384L25.2613 26.7016L27.5676 24.3951L26.6044 23.4319Z",
    fill: "url(#paint4_linear_224_693)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_693",
    x1: 0,
    y1: 0,
    x2: 37,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F80ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CCF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_224_693",
    x1: 28.4846,
    y1: 10.9728,
    x2: 1.53366,
    y2: 11.9394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_224_693",
    x1: 26.7701,
    y1: 23,
    x2: 27.9995,
    y2: 24.2295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70EFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_224_693",
    x1: 23.9998,
    y1: 25.9434,
    x2: 25.0564,
    y2: 26.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70EFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_224_693",
    x1: 24.2981,
    y1: 23.4319,
    x2: 27.5678,
    y2: 26.7014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70EFDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVee);
export default __webpack_public_path__ + "static/media/vee.4d3df8be507290a4a4c7e198769a887a.svg";
export { ForwardRef as ReactComponent };